export default function (props: any) {
    return (
        <svg
            {...props}
            width="45px"
            height="36px"
            viewBox="0 0 45 36"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <defs>
                <rect id="path-1" x="0" y="0" width="45" height="36"></rect>
            </defs>
            <g id="通用产品预览页" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="M端-通用产品预览页--Solutions" transform="translate(-152.000000, -168.000000)">
                    <g id="编组-12" transform="translate(38.000000, 168.000000)">
                        <g id="编组-10" transform="translate(100.000000, 0.000000)">
                            <g id="导航栏Components" transform="translate(14.000000, 0.000000)">
                                <mask id="mask-2" fill="white">
                                    <use xlinkHref="#path-1"></use>
                                </mask>
                                <g id="矩形"></g>
                                <g id="Frame" mask="url(#mask-2)">
                                    <g transform="translate(1.000000, 1.000000)">
                                        <rect
                                            id="矩形"
                                            stroke="#000000"
                                            strokeWidth="1.46571429"
                                            fill="none"
                                            x="8.30681818"
                                            y="0"
                                            width="26.3863636"
                                            height="14.5714286"
                                            rx="2.93142857"
                                        ></rect>
                                        <line
                                            x1="21.5"
                                            y1="16.5142857"
                                            x2="21.5"
                                            y2="23.8"
                                            id="路径"
                                            stroke="#000000"
                                            strokeWidth="1.46571429"
                                            fill="none"
                                            strokeLinecap="square"
                                            strokeLinejoin="round"
                                        ></line>
                                        <rect
                                            id="矩形"
                                            stroke="#000000"
                                            strokeWidth="1.62857143"
                                            fill="none"
                                            x="0"
                                            y="24.2857143"
                                            width="12.7045455"
                                            height="9.71428571"
                                            rx="2.17142857"
                                        ></rect>
                                        <path
                                            d="M10.75,14.5714286 L16.6136364,14.5714286 L16.6136364,16.0257143 C16.6136364,16.2955448 16.3948955,16.5142857 16.1250649,16.5142857 L11.2385714,16.5142857 C10.9687409,16.5142857 10.75,16.2955448 10.75,16.0257143 L10.75,14.5714286 L10.75,14.5714286 Z"
                                            id="矩形"
                                            stroke="none"
                                            fill="#000000"
                                            fillRule="evenodd"
                                        ></path>
                                        <path
                                            d="M18.5681818,14.5714286 L24.4318182,14.5714286 L24.4318182,16.0257143 C24.4318182,16.2955448 24.2130773,16.5142857 23.9432468,16.5142857 L19.0567532,16.5142857 C18.7869227,16.5142857 18.5681818,16.2955448 18.5681818,16.0257143 L18.5681818,14.5714286 L18.5681818,14.5714286 Z"
                                            id="矩形"
                                            stroke="none"
                                            fill="#000000"
                                            fillRule="evenodd"
                                        ></path>
                                        <path
                                            d="M26.3863636,14.5714286 L32.25,14.5714286 L32.25,16.0257143 C32.25,16.2955448 32.0312591,16.5142857 31.7614286,16.5142857 L26.8749351,16.5142857 C26.6051045,16.5142857 26.3863636,16.2955448 26.3863636,16.0257143 L26.3863636,14.5714286 L26.3863636,14.5714286 Z"
                                            id="矩形"
                                            stroke="none"
                                            fill="#000000"
                                            fillRule="evenodd"
                                        ></path>
                                        <rect
                                            id="矩形"
                                            stroke="#000000"
                                            strokeWidth="1.62857143"
                                            fill="none"
                                            x="15.1477273"
                                            y="24.2857143"
                                            width="12.7045455"
                                            height="9.71428571"
                                            rx="2.17142857"
                                        ></rect>
                                        <rect
                                            id="矩形"
                                            stroke="#000000"
                                            strokeWidth="1.62857143"
                                            fill="none"
                                            x="30.2954545"
                                            y="24.2857143"
                                            width="12.7045455"
                                            height="9.71428571"
                                            rx="2.17142857"
                                        ></rect>
                                        <path
                                            d="M29.3181818,16.5142857 C29.3181818,18.0927572 30.5977858,19.3723612 32.1762573,19.3723612 L33.9441925,19.3723612 C35.5631758,19.3723612 36.8756211,20.6848064 36.8756211,22.3037897 L36.8756211,23.3142857 L36.8756211,23.3142857"
                                            id="路径-2"
                                            stroke="#000000"
                                            strokeWidth="1.46571429"
                                            fill="none"
                                            strokeLinecap="square"
                                            strokeLinejoin="round"
                                        ></path>
                                        <path
                                            d="M5.86363636,16.5142857 C5.86363636,18.0927572 7.14324033,19.3723612 8.72171181,19.3723612 L10.7503896,19.3723612 C12.3693729,19.3723612 13.6818182,20.6848064 13.6818182,22.3037897 L13.6818182,23.3142857 L13.6818182,23.3142857"
                                            id="路径-2"
                                            stroke="#000000"
                                            strokeWidth="1.46571429"
                                            fill="none"
                                            strokeLinecap="square"
                                            strokeLinejoin="round"
                                            transform="translate(9.772727, 19.914286) scale(-1, 1) translate(-9.772727, -19.914286) "
                                        ></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
